import Training from '../components/pages/Training';

export default Training;
